export default "__VITE_ASSET__BkfAIavG__"